// extracted by mini-css-extract-plugin
export default {"title":"confirm_title__tW17f"};